import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CadastroFormDrawer from '../Components/CadastroFormDrawer/CadastroFormDrawer';
import { fetchChamadosAutomaticosAtivos } from '../../api/chamadosAutomaticos';
import filtrarUsuarioIA from '../../FuncoesGerais/filtrarUsuarioIA';
import { ensureProtocol } from '../../config/backend';

function DrawerChamadoAutomatico({ open, onClose, codAte, onSuccess }) {
  const [templates, setTemplates] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [templateId, setTemplateId] = useState('');
  const [solicitanteId, setSolicitanteId] = useState('');
  const [satEmlSol, setSatEmlSol] = useState('');
  const [horasTrabalhadas, setHorasTrabalhadas] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [erro, setErro] = useState('');
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    if (!open) return;
    setErro('');
    setMensagem('');
    setTemplateId('');
    setSolicitanteId('');
    setSatEmlSol('');
    setHorasTrabalhadas('');
    setLoading(true);
    const token = localStorage.getItem('token');
    const base = ensureProtocol(localStorage.getItem('ipBackend2') || '');
    Promise.all([
      fetchChamadosAutomaticosAtivos(),
      base
        ? axios.get(base + '/usuarios/ativos', { headers: { Authorization: token } }).then((r) => {
            const raw = Array.isArray(r?.data) ? r.data : [];
            return filtrarUsuarioIA(raw, 'USRNOMCPL');
          })
        : Promise.resolve([])
    ])
      .then(([list, usrList]) => {
        setTemplates(Array.isArray(list) ? list : []);
        setUsuarios(usrList || []);
        if ((list || []).length === 0) {
          setMensagem('Cadastre modelos em Cadastros → Chamados automáticos para usar esta função.');
        }
      })
      .catch((e) => {
        setErro(e?.response?.data?.error || 'Erro ao carregar dados.');
      })
      .finally(() => setLoading(false));
  }, [open]);

  useEffect(() => {
    if (!solicitanteId || !open) {
      setSatEmlSol('');
      return;
    }
    const base = ensureProtocol(localStorage.getItem('ipBackend2') || '');
    const token = localStorage.getItem('token');
    axios
      .get(base + '/usuarios/solicitante', {
        headers: { Authorization: token },
        params: { solicitante: solicitanteId }
      })
      .then((r) => {
        const eml = r?.data?.[0]?.USREML ?? r?.data?.[0]?.usreml ?? '';
        setSatEmlSol(eml);
      })
      .catch(() => setSatEmlSol(''));
  }, [solicitanteId, open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!templateId) {
      setErro('Selecione um modelo de chamado.');
      return;
    }
    if (!solicitanteId) {
      setErro('Selecione o solicitante (usuário).');
      return;
    }
    setErro('');
    setLoadingSubmit(true);
    const base = ensureProtocol(localStorage.getItem('ipBackend2') || '');
    const token = localStorage.getItem('token');
    const payload = {
      template_id: Number(templateId),
      codUsu: Number(solicitanteId),
      satAte: codAte,
      satEmlSol: satEmlSol || '',
      horas_trabalhadas: horasTrabalhadas !== '' && horasTrabalhadas != null ? Number(horasTrabalhadas) : undefined
    };
    try {
      await axios.post(base + '/satis/automatica', payload, {
        headers: { Authorization: token }
      });
      if (typeof onSuccess === 'function') onSuccess();
      onClose();
    } catch (err) {
      setErro(err?.response?.data?.error || 'Erro ao cadastrar chamado.');
    } finally {
      setLoadingSubmit(false);
    }
  };

  if (!open) return null;

  return (
    <CadastroFormDrawer
      open={open}
      onClose={onClose}
      title="Chamado automático (registro rápido)"
    >
      <div className="cadastro-form-drawer-form drawer-chamado-automatico">
        {loading && <p className="text-muted">Carregando...</p>}
        {!loading && mensagem && <p className="text-muted small">{mensagem}</p>}
        {!loading && templates.length > 0 && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Modelo de chamado</label>
              <select
                value={templateId}
                onChange={(e) => setTemplateId(e.target.value)}
                className="form-control form-control-sm"
                required
              >
                <option value="">Selecione...</option>
                {templates.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.nome}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Solicitante (usuário)</label>
              <select
                value={solicitanteId}
                onChange={(e) => setSolicitanteId(e.target.value)}
                className="form-control form-control-sm"
                required
              >
                <option value="">Selecione...</option>
                {usuarios.map((u) => (
                  <option key={u.USUSEQ ?? u.ususeq} value={u.USUSEQ ?? u.ususeq}>
                    {u.USRNOMCPL ?? u.usrnomcpl ?? u.USUSEQ ?? u.ususeq}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Horas trabalhadas (opcional, em minutos)</label>
              <input
                type="number"
                min="0"
                step="1"
                value={horasTrabalhadas}
                onChange={(e) => setHorasTrabalhadas(e.target.value)}
                className="form-control form-control-sm"
                placeholder="Ex.: 30"
              />
            </div>
            {erro && <div className="alert alert-danger py-2 mb-2">{erro}</div>}
            <div className="cadastro-form-drawer-form__actions">
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                Cancelar
              </button>
              <button type="submit" className="btn btn-primary btn-sm" disabled={loadingSubmit}>
                {loadingSubmit ? 'Cadastrando...' : 'Cadastrar e fechar'}
              </button>
            </div>
          </form>
        )}
      </div>
    </CadastroFormDrawer>
  );
}

export default DrawerChamadoAutomatico;
